import Vue from 'vue';
import TitleBlock from './TitleBlock';
import ImageBlock from './ImageBlock';

Vue.component('title-block', TitleBlock)
Vue.component('image-block', ImageBlock)